import React from 'react';
import PropTypes from 'prop-types';

import { JobForm } from 'src/components/JobForm/JobForm';
import { noop } from 'src/utils/core/event';
import { useData, usePage, useFormSave, useSetStatus } from 'src/pages/JobPage/hooks';
import Loader from 'src/components/Loader';
import Page from 'src/components/Page';

const JobPage = ({ match }) => {
  const {
    allAuditorActionsNeededCount,
    allNoteCount,
    allReviewerActionsNeededCount,
    allExternalActionsNeededCount,
    auth,
    capFindingsData,
    capFindingsLoading,
    closedNoteCount,
    companyTypes,
    fullJobLoading,
    getResultHistories,
    isNew,
    isInternalUser,
    isReportReviewer,
    job,
    jobChecklistResults,
    jobDatasheetResults,
    isDatasheetResultsLoaded,
    isLoadingSaqJobExternalStakeholders,
    jobMeta,
    jobloading,
    loading: relatedLoading,
    permissions,
    refetchReportReview,
    refetchResultHistories,
    reloadCapFindings,
    reloadJob,
    reloadJobChecklistResults,
    reloadJobDatasheetResults,
    reportReviewData,
    reportReviewStatistics,
    resultHistories,
    resultHistoriesDataLoading,
    saqJobExternalStakeholdersData,
    updateCapQueryCache,
  } = useData(match);
  const onSetStatus = useSetStatus(reloadJob);
  const { loading } = usePage({ job, isNew });

  const { isLoading: isSavingJobResultsLoading, saveJobChecklistResults, saveJobDatasheetResults } = useFormSave(
    job.id,
    {
      reloadJobChecklistResults,
      reloadJobDatasheetResults,
      reloadJob,
      job,
    },
  );

  if (fullJobLoading) return <Loader />;
  return (
    <Page>
      {loading && <Loader left />}
      {!loading && (
        <JobForm
          allAuditorActionsNeededCount={allAuditorActionsNeededCount}
          allNoteCount={allNoteCount}
          allReviewerActionsNeededCount={allReviewerActionsNeededCount}
          allExternalActionsNeededCount={allExternalActionsNeededCount}
          auth={auth}
          capFindingsData={capFindingsData}
          capFindingsLoading={capFindingsLoading}
          closedNoteCount={closedNoteCount}
          companyTypes={companyTypes}
          currentUserPermissions={permissions}
          fullJobLoading={fullJobLoading}
          getResultHistories={getResultHistories}
          isInternalUser={isInternalUser}
          isLoadingSaqJobExternalStakeholders={isLoadingSaqJobExternalStakeholders}
          isReportReviewer={isReportReviewer}
          isSavingJobResultsLoading={isSavingJobResultsLoading}
          job={job}
          jobChecklistResults={jobChecklistResults}
          jobDatasheetResults={jobDatasheetResults}
          isDatasheetResultsLoaded={isDatasheetResultsLoaded}
          jobMeta={jobMeta}
          loading={jobloading}
          onSetStatus={onSetStatus}
          refetchReportReview={refetchReportReview}
          refetchResultHistories={refetchResultHistories || noop}
          reloadJobChecklistResults={reloadJobChecklistResults}
          reloadJobDatasheetResults={reloadJobDatasheetResults}
          reloadCapFindings={reloadCapFindings}
          reportReviewData={reportReviewData}
          reportReviewStatistics={reportReviewStatistics}
          resultHistories={resultHistories}
          resultHistoriesDataLoading={resultHistoriesDataLoading}
          reloadJob={reloadJob}
          saqJobExternalStakeholdersData={saqJobExternalStakeholdersData}
          saveJobChecklistResults={saveJobChecklistResults}
          saveJobDatasheetResults={saveJobDatasheetResults}
          updateCapQueryCache={updateCapQueryCache}
        />
      )}
    </Page>
  );
};

JobPage.propTypes = {
  match: PropTypes.shape({}).isRequired,
};

export default React.memo(JobPage);
